import { alpha, SxProps, TableRow } from "@mui/material";
import { ReactElement } from "react";
import TableLinkRow from "../tableLinkRow/TableLinkRow";

type RowVariant = "disabled" | "secondary";

type Props = {
  to?: string;
  children: ReactElement | ReactElement[];
  rowVariant?: RowVariant;
  customColor?: string;
  sx?: SxProps;
};

const GroupedTableRowComponent = ({
  to,
  rowVariant,
  customColor,
  sx,
  children,
}: Props) => {
  const sxProps = {
    ...sx,
    ...(customColor && {
      backgroundColor: customColor,
      "&: hover": { backgroundColor: alpha(customColor, 0.4) },
    }),
    opacity: rowVariant ? 0.6 : 1,
    cursor: rowVariant === "disabled" ? "auto" : "pointer",
    "& td": { borderBottom: "none" },
  };

  return to ? (
    <TableLinkRow to={to} TableRowProps={{ sx: sxProps }}>
      {children}
    </TableLinkRow>
  ) : (
    <TableRow sx={sxProps}>{children}</TableRow>
  );
};

export default GroupedTableRowComponent;
